import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  margin-left: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: ${Theme.colors.G_2};

  &:hover {
    color: ${Theme.colors.B_3};
  }
`;
